.button_option {
  display: flex;
  height: 80px;
  padding-right: 10px;
  align-items: center;
  gap: 9.375px;
  align-self: stretch;
  border-radius: 10px;
  border: 0.938px solid #C3C3C3;
  background: #F2F2F2;
  width: 100%;
  overflow: hidden;

  > label {
    width: 100%;
  }
  .form_control {
    display: none;
  }

  .title {
    color: #000;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 18.75px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 24.375px */
    @media (max-width: 991px) {
      font-size: 14px;
    }
  }

  .data_wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px; /* 100% */

    @media (max-width: 991px) {
      font-size: 12px;
    }

    .innerPriceContainer {
      display: flex;
      flex-direction: row;
      gap: 5px;
      .price_wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        align-content: center;
        gap: 5px;
        .compare_price {
          color: #666666;
          text-decoration-line: line-through;
        }
        .price {
          color: #D61E2D;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 15px;
          @media (max-width: 991px) {
            font-size: 14px;
          }
        }
      }
      .btn_savings {
        display: flex;
        padding: 2px 3px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        background: #000;
        color: #FFF;
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 15px; /* 107.143% */
        @media (max-width: 991px) {
          font-size: 11px;
        }
      }

    }
  }

  .content_wrapper {
    display: flex;
    gap:10px;
    justify-content: center;
    align-items: center;
    flex-direction: row;

  }
  .check_wrapper {
    margin-left: auto;
    margin-right: 0;
  }

  .img {
    background-color: #fff;
    width: 78px;
    flex-shrink: 0;

    img {
      width: 100%;
      aspect-ratio: 1 / 1;
    }
  }
}

.switch {
  font-size: 16px;
  position: relative;
  display: inline-block;
  width: 3.5em;
  height: 2em;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #575757;
  border: 1px solid #adb5bd;
  transition: .4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 1.45em;
  width: 1.45em;
  border-radius: 20px;
  left: 0.22em;
  bottom: 0.20em;
  background-color: #fff;
  transition: .4s;
}

input:checked + .slider {
  background-color: #007bff;
  border: 1px solid #007bff;
}

input:focus + .slider {
  box-shadow: 0 0 1px #007bff;
}

input:checked + .slider:before {
  transform: translateX(1.4em);
  background-color: #fff;
}